import { render } from "./HeadCount.vue?vue&type=template&id=5f98080e&scoped=true"
import script from "./HeadCount.vue?vue&type=script&lang=js"
export * from "./HeadCount.vue?vue&type=script&lang=js"

import "./HeadCount.vue?vue&type=style&index=0&id=5f98080e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f98080e"]])

export default __exports__